import React from 'react';
import { GOOGLE_MAP_KEY } from '../../utils/Config';
import '../../assets/style/TrackLocation.css';
import { APIProvider } from '@vis.gl/react-google-maps';
import TrackLocationMap from './TrackLocationMap';

const TrackLocation: React.FunctionComponent = () => {
  return (
    <APIProvider apiKey={GOOGLE_MAP_KEY}>
      <TrackLocationMap />
    </APIProvider>
  );
};

export default TrackLocation;
